import { Grid } from "@mui/material";
import React from "react";
import JSupplierTable from "./home/table";
import JSupplierHeader from "./home/header";

const JSupplier = () => {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <JSupplierHeader />
      </Grid>
      <Grid item xs={12}>
        <JSupplierTable />
      </Grid>
    </Grid>
  );
};

export default JSupplier;
